import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
import * as rules from 'vee-validate/dist/rules';

// check brand for type change
const brandID = process.env.VUE_APP_BRAND_ID;
// type change: JAC is Roboto
switch (brandID) {
  case 'JAC': {
    // roboto from google fonts: import
    const robotoscript = document.createElement('link');
    Object.assign(robotoscript, {
      href:
        'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;1,400;1,700&display=swap',
      rel: 'stylesheet',
    });
    document.head.appendChild(robotoscript);
    // roboto from google fonts: set in css stylesheet
    var sheet = window.document.styleSheets[0];
    sheet.insertRule(
      'body { font-family: "Roboto" !important; }',
      sheet.cssRules.length,
    );
  }
}

String.prototype.toSlug = function() {
  var str = this.valueOf();
  str = str.replace(/^\s+|\s+$/g, '');

  // Make the string lowercase
  str = str.toLowerCase();

  // Remove accents, swap ñ for n, etc
  var from =
    'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;';
  var to =
    'AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------';
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  // Remove invalid chars
  str = str
    .replace(/[^a-z0-9 -]/g, '')
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-')
    // Collapse dashes
    .replace(/-+/g, '-');

  return str;
};

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize('es', es);

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

extend('rut', {
  validate: rutValidation,
  message: 'El campo {_field_} no tiene un formato válido',
});

// Set de patentes inválidas para búsqueda rápida.
const invalidPatents = new Set([
  '1111-1',
  'AAAAAA',
  'AAAA-A',
  'AAA-11',
  '111-AA',
]);

// Regex para detectar letras minúsculas y caracteres no permitidos.
const lowercaseRegex = /[a-z]/;
const specialCharRegex = /[^A-Z0-9-]/;

extend('validPatent', {
  validate: value => {
    // Verifica que el valor no sea nulo y sea una cadena.
    if (!value || typeof value !== 'string') return false;

    // Verifica que no contenga espacios.
    if (value.includes(' ')) return false;

    // Verifica que no contenga letras minúsculas o caracteres no permitidos.
    if (lowercaseRegex.test(value)) return false;
    if (specialCharRegex.test(value)) return false;

    // Verifica que no esté en el conjunto de patentes inválidas.
    return !invalidPatents.has(value);
  },

  // Mensaje de error para patentes inválidas.
  message: 'El campo {_field_} no tiene una patente válida',
});

import vRut from 'v-rut';
import { validate as rutValidation } from 'v-rut/dist/VeeRutValidator';

Vue.use(vRut);

import Notifications from 'vue-notification';

Vue.use(Notifications);

import '@/assets/scss/app.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
